module.exports = __webpack_public_path__ + "static/media/empty_projects_tabby.6fa75254.png";